import gql from 'graphql-tag';

export default gql`
  mutation adminArchiveSite($siteId: ID!) {
    adminArchiveSite(siteId: $siteId) {
      id
    }
  }
`;
